import { getTextContentFromHtml } from 'sanitize-text/sanitizers/TextSanitizer';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyHtml = props => {
  useComponentMountMetric('FormattedPropertyHtml');
  const propertyValue = usePropertyValue();
  const {
    placeholder
  } = props;
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: propertyValue ? getTextContentFromHtml(propertyValue) : placeholder
  }));
};
FormattedPropertyHtml.displayName = 'FormattedPropertyHtml';
export default FormattedPropertyHtml;